<div class="not-found-wrapper">

  <div class="not-found-container">

    <h2>404</h2>
    <h3><span aria-hidden="true" class="material-symbols-sharp not-found-icon me-2">search_off</span> {{ 'NotFound.MESSAGE' | translate }}</h3>

  </div>

</div>
